export const ORDER_RECEIPT_FLOW = 'orderReceipt';
